export const meetingsUrl = process.env.RAZZLE_RUNTIME_MEETINGS_URL;
export const alkymindBaseURL = process.env.RAZZLE_RUNTIME_ALKYMIND_URL;
